export default import.meta.ROLLUP_FILE_URL_bpKh$G$BaVovYgUnGP8G0w